<template>
	<div :class="['dropdown-component', classes]">
		<button class="dropdown-component-label" @click="toggle($event)">
			<span class="dropdown-component-label-text">
				<slot name="label"></slot>
			</span>
			<span class="dropdown-component-label-toggle">
				
			</span>
		</button>
		<div class="dropdown-component-body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {

		props: {
			initialState: {
				type: Boolean,
				default: false
			},
			initialClasses: {
				type: String,
				default: '',
			}
		},

		data () {
			return {
				isActive: this.initialState
			}
		},

		computed: {
			classes () {
				if (this.isActive) {
					return 'is-active ' + this.initialClasses;
				} else {
					return this.initialClasses;
				}
			}
		},

		methods: {
			open (e) {
				this.isActive = true;
			},

			close (e) {
				this.isActive = false;
			},

			toggle (e) {
				return (this.isActive ? this.close(e) : this.open(e));
			}
		}
	}
</script>